import React from "react";
import type { IMemberDetail } from "service/interface/member";

interface Props {
  data: IMemberDetail;
}

export function BookmarkTable({ data }: Props) {
  return (
    <div>
      <div className="mb-[24px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          찜 목록
        </p>
      </div>
      <div className="w-full border-t-[2px] border-t-black p-0">
        <div className="max-h-[348px] overflow-auto">
          {data.UserBookmarkPark?.map((bookmark, idx) => (
            <div
              key={idx}
              className="flex h-[58px] w-full border-b-[1px] border-b-gray-1"
            >
              <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
                업체명
              </div>
              <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
                {bookmark.name}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
